import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { HumanFactorResponse } from '../models/cleaver_hr_form_model';

@Injectable({
  providedIn: 'root'
})
export class CleaverService {

  constructor(private http:HttpClient) { }


  createQuestion(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/cleaver/createQuestion`, data);
  }

  getQuestions():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/cleaver/getQuestions`);
  }

  getQuestion(_id):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/cleaver/getQuestion?_id=${_id}`);
  }

  updateQuestion(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/cleaver/updateQuestion`, data);
  }

  createFactor(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/cleaver/createFactor`, data);
  }

  getFactors():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/cleaver/getFactors`);
  }

  createReport(s,a, o):Observable<any>{
    const ob={
      score:s,
      answers:a,
      originalScore:o
    }
    return this.http.post(`${environment.apiBaseUrl}/cleaver/createReport`, ob);
  }


  getReport(id): Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/cleaver/getReport?id=${id}`);
  }

  createOrUpdateHumanFactor(data: HumanFactorResponse): Observable<HumanFactorResponse> {
    return this.http.post<HumanFactorResponse>(`${environment.apiBaseUrl}/cleaver/createOrUpdateHumanFactor`, data);
  }

  getHumanFactors(query: object): Observable<HumanFactorResponse[]> {
    return this.http.post<HumanFactorResponse[]>(`${environment.apiBaseUrl}/cleaver/getHumanFactors`, query);
  }


}
